import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, NavigationEnd, NavigationError} from '@angular/router';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent implements OnInit {

  constructor( private router: Router) {

  }
  ngOnInit() {

  }
  goBack() {
    history.go(-1);
  }
}
